var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "job-content-table",
        { attrs: { title: "希望の指定" } },
        [
          _c(
            "job-content-table-outline-sub",
            _vm._g(
              {
                attrs: {
                  title: "希望職種",
                  "target-ids":
                    _vm.targetIdMap.matching.desired.occupation.list,
                  contents: _vm.occupations,
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.matching.desired.occupation.prefix
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "希望業種",
                  "target-id": _vm.targetIdMap.matching.desired.business,
                  value: _vm.createJoinedText(
                    _vm.matching.desiredBusinessNameList
                  ),
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.desired.business
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "希望勤務地",
                  "target-id": _vm.targetIdMap.matching.desired.workPlace,
                  value: _vm.createJoinedText(
                    _vm.matching.desiredWorkPlaceList
                  ),
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.desired.workPlace
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
          _vm._v(" "),
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "希望雇用形態",
                  "target-id": _vm.targetIdMap.matching.desired.employment,
                  value: _vm.createJoinedText(
                    _vm.matching.desiredEmploymentList
                  ),
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.desired.employment
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "フリーワード" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "フリーワード",
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.matching.freeWord.prefix
                  ),
                  "highlight-mode": _vm.highlightMode,
                  "data-test": "freeWord",
                },
                scopedSlots: _vm._u([
                  {
                    key: "body",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v(
                            "\n          「職務経歴内容」「保有資格」「その他の外国語」「自己PR」から、フリーワード検索をおこないます。（400文字以内）"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          ※上記項目に登録がない会員は検索対象外となります。また、他の設定条件との掛け合わせでキーワードによってはマッチング条件が厳しくなりすぎる恐れがあります。"
                          ),
                          _c("br"),
                          _vm._v("\n          キーワード（スペース区切り）:"),
                          _c("br"),
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "pega-break",
                          attrs: { id: _vm.targetIdMap.matching.freeWord.word },
                          domProps: {
                            textContent: _vm._s(
                              _vm.matching.freeWord || "未登録"
                            ),
                          },
                        }),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "pega-break",
                          attrs: {
                            id: _vm.targetIdMap.matching.freeWord.label,
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.matching.freeWordSearchLabel || "未登録"
                            ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "job-content-table",
        { attrs: { title: "活動履歴の指定" } },
        [
          _c(
            "job-content-table-outline",
            _vm._g(
              {
                attrs: {
                  title: "新規会員の指定",
                  "target-id": _vm.targetIdMap.matching.registrationDate,
                  value: _vm.matching.registrationDate,
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.matching.registrationDate
                  ),
                  "highlight-mode": _vm.highlightMode,
                },
              },
              _vm.$listeners
            ),
            [
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "※検索する求職者（女の転職type会員）の対象範囲を指定してください。"
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }